import VehicleInfo from './VehicleInfo';

export default VehicleInfo;
